import { useEffect, useState } from "react";

const TARGET = new Date("2027-01-26T00:00:00Z").getTime();

const UNITS = [
  { key: "days", label: "DAYS" },
  { key: "hours", label: "HOURS" },
  { key: "minutes", label: "MINUTES" },
  { key: "seconds", label: "SECONDS" },
];

const compute = () => {
  const diff = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
};

export const Countdown = () => {
  const [t, setT] = useState(compute);

  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="countdown-timer" className="rounded-2xl border border-slate-200 bg-white shadow-sm">
      <p className="border-b border-slate-100 px-5 pt-4 pb-3 font-mono text-[10px] tracking-[0.25em] text-gold">
        TERM 1 BEGINS — 26 JANUARY 2027
      </p>
      <div className="grid grid-cols-4 divide-x divide-slate-100">
        {UNITS.map((u) => (
          <div key={u.key} className="flex flex-col items-center gap-1 py-4 px-2">
            <span
              data-testid={`countdown-timer-${u.key}`}
              className="font-mono text-3xl sm:text-4xl font-semibold tracking-tight text-navy tabular-nums"
            >
              {String(t[u.key]).padStart(2, "0")}
            </span>
            <span className="font-mono text-[9px] tracking-[0.3em] text-slate-400">{u.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
